import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { DataEventProps } from '../../../../libraries/wpl/foundations/src/data-event-props';

export interface ProductNavLinkProps {
	label: string; // header link text
	href: string; // link
	isSelected?: boolean;
	dataEventProps?: DataEventProps;
}

const linkStyle = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& a': {
		position: 'relative',
		insetBlockStart: '3px',
		display: 'block',
		fontSize: '1rem',
		lineHeight: 1,
		[media.above.md]: {
			margin: `0 ${token('space.200')}`,
			padding: `${token('space.200')} 0`,
			color: '#0052cc',
			boxSizing: 'border-box',
			borderBlockEnd: '3px solid white',
			textDecoration: 'none',
			'&:hover': {
				// eslint-disable-next-line local/ensure-wac-token-usage
				borderBlockEnd: '3px solid #dfe1e5',
				// eslint-disable-next-line local/ensure-wac-token-usage
				color: 'rgb(0, 101, 255)',
			},
		},
		[media.below.md]: {
			width: '100%',
			padding: `${token('space.200')} 10px`,
			margin: `0 ${token('space.200')}`,
			// eslint-disable-next-line local/ensure-wac-token-usage
			color: '#0052cc',
			insetInlineEnd: '10px',
			textDecoration: 'underline',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
			'&:hover': {
				textDecoration: 'none',
				// eslint-disable-next-line local/ensure-wac-token-usage
				color: 'rgb(0, 101, 255)',
				boxSizing: 'border-box',
				// eslint-disable-next-line local/ensure-wac-token-usage
				backgroundColor: '#ebecf0',
			},
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.selected': {
		fontWeight: 600,
		[media.above.md]: {
			// eslint-disable-next-line local/ensure-wac-token-usage
			borderBlockEnd: '3px solid #0053cc',
			'&:hover': {
				// eslint-disable-next-line local/ensure-wac-token-usage
				borderBlockEnd: '3px solid #0053cc',
			},
		},
	},
});

export const ProductNavLink = (props: ProductNavLinkProps) => {
	return (
		<div css={linkStyle}>
			<a
				className={props.isSelected ? 'selected' : ''}
				href={props.href}
				{...props.dataEventProps}
				data-label={props.label}
			>
				{props.label}
			</a>
		</div>
	);
};

export default ProductNavLink;
